import { instance } from './instance';

export const userService = {
  async getUsers() {
    const response = await instance.get('/Users');
    return response.data;
  },

  async getUser(id) {
    const response = await instance.get(`/Users/${id}`);
    return response.data;
  },

  async createUser(data) {
    const response = await instance.post('/Users', data);
    return response.data;
  },

  async updateUser(id, data) {
    const response = await instance.put(`/Users/${id}`, data);
    return response.data;
  },

  async deleteUser(id) {
    return instance.delete(`/Users/${id}`);
  },

  async changePassword(data) {
    const response = await instance.post('/users/change-password', data);
    return response.data;
  }
};
